<template>
<div class="wrap">
  <div class="op">
    <div class="area lis">
      <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
      </div>
      <div class="age lis">
       <el-select size="mini" clearable v-model="age" placeholder="选择年龄">
    <el-option
      v-for="item4 in ageLists"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
    </div>
    <div class="age lis">
       <el-select size="mini" clearable v-model="quarter" placeholder="选择季度">
    <el-option
      v-for="item4 in quarterList"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
    </div>
    <div class="age lis">
       <el-select size="mini" clearable v-model="year" placeholder="选择年份">
    <el-option
      v-for="item4 in yearList"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
    </div>
    <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serchCode(110010)">搜索</el-button>
  </div>
    <div class="con" id="continer">
  
  </div>
  </div>
</template>
<style scoped>
.op {
  display: flex;
}
.lis {
  margin-left: 10px;
}
#continer {
  width: 100%;
  height: 70vh;
  margin-top: 20px;
}
</style>
<script>
import Candode from "../Core/candode";
var echarts = require("echarts");

export default {
  components: {
    Candode
  },
  data() {
    return {
      countNum: 0,
      moneyNum: 0,
      moneyArr: [],
      EchartsMes: "",
      seriesList: [],
      townList: "",
      townlen: "",
      age: "",
      Page: 1,
      totals: 0,
      ageLists: [],
      //季度
      quarter: "",
      quarterList: [
        {
          label: "一季度",
          value: "3"
        },
        {
          label: "二季度",
          value: "6"
        },
        {
          label: "三季度",
          value: "9"
        },
        {
          label: "四季度",
          value: "12"
        }
      ],
      //年份
      year: "",
      yearList: [],
      tableData: []
    };
  },
  methods: {
    childByValue(val) {
      this.townList = val;
    },
    current_change(s) {
      this.serchCode(s);
    },
    getTownlength(val) {
      this.townlen = val;
    },
    serchCode(s) {
      if (s == 110010) {
        s = this.Page;
      } else {
        s = s;
      }

      let data = {
        pageNum: s,
        pageSize: 10,
        personName: this.name ? this.Encrypt(this.name) : "",
        province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
        city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
        county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
        town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
        village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        quarter: this.quarter,
        birthday: this.age,
        start_time: this.year
      };
      this.$api.getlist
        .selectAnalyze(data)
        .then(res => {
          if (res.code == 200) {
            let result = res.data.list;
            this.totals = res.data.total;
            this.tableData = result;
          } else {
            this.$message(res.message);
          }
        })
        .catch(res => {
          this.$message(JSON.stringify(res));
        });
    },
    getEcharts() {
      var myChart = echarts.init(document.getElementById("continer"));
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.EchartsMes.age
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // link: null,
            animation: true,
            type: "cross"
          },
          formatter: params => {
            //在此处直接用 formatter 属性
            var showdata = params;
            let moneyNum = 0;
            let countNum = 0;
            for (let i in this.EchartsMes.age) {
              //console.log(this.moneyArr[showdata[i].dataIndex][i])
              moneyNum += this.moneyArr[showdata[i].dataIndex][i];
              countNum += showdata[i].value;
            }
            // for(let i in this.EchartsMes.age){
            //     moneyNum+=this.moneyArr[showdata[i].dataIndex];
            //     countNum+=showdata[i].value
            // }
            //console.log(params[0].dataIndex)
            // 根据自己的需求返回数据
            console.log(showdata);
            return `
                                         <div>发放总额：<a style="color: #00E8D7">${moneyNum}元</a> 发放总人数：<a style="color: #00E8D7">${countNum}</a>人</div>
                                         <div>55岁以下金额：<a style="color: #00E8D7">${
                                           this.moneyArr[
                                             showdata[0].dataIndex
                                           ][0]
                                         }元</a> 人数：<a style="color: #00E8D7">${
              showdata[0].value
            }</a>人</div>
                                         <div>55岁-59岁金额：<a style="color: #00E8D7">${
                                           this.moneyArr[
                                             showdata[1].dataIndex
                                           ][1]
                                         }元</a> 人数：<a style="color: #00E8D7">${
              showdata[1].value
            }</a>人</div>
                                         <div>60岁-80岁金额：<a style="color: #00E8D7">${
                                           this.moneyArr[
                                             showdata[2].dataIndex
                                           ][2]
                                         }元</a> 人数：<a style="color: #00E8D7">${
              showdata[2].value
            }</a>人</div>
                                        `;
          }
        },
        yAxis: {
          type: "value",
          name: "人数"
        },
        xAxis: {
          type: "category",
          name: "月份",
          data: this.EchartsMes.mounth
        },
        series: this.seriesList
      };
      myChart.setOption(options);
    }
  },
  mounted() {
    this.EchartsMes = {
      count: [
        [320, 302, 301, 334, 390, 330, 320, 230, 190, 330, 320, 230],
        [120, 132, 101, 134, 90, 230, 210, 120, 190, 330, 320, 230],
        [220, 182, 191, 234, 290, 330, 310, 120, 910, 330, 320, 230],
        [220, 182, 191, 234, 290, 330, 310, 120, 910, 330, 320, 230],
        [820, 832, 901, 934, 1290, 1330, 1320, 1231, 100, 330, 320, 230],
        [220, 182, 191, 234, 290, 330, 310, 120, 910, 330, 320, 230]
      ],
      mounth: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      age: ["80岁-90岁", "90岁-100岁", "100岁以上"],
      money: [
        [1320, 2302, 3301, 334, 390, 3320, 320, 230, 1290, 2330, 3220, 230],
        [2120, 2132, 1021, 134, 90, 2340, 210, 4120, 1390, 330, 3220, 230],
        [2220, 2182, 1291, 234, 290, 3304, 310, 120, 910, 330, 3220, 230],
        [2220, 2182, 1291, 2234, 2290, 330, 310, 120, 910, 330, 3202, 230],
        [
          8220,
          8232,
          2201,
          2934,
          1290,
          1330,
          1320,
          1231,
          1200,
          33230,
          3220,
          230
        ],
        [2220, 1282, 2191, 2324, 2290, 3230, 2310, 2120, 9210, 3230, 2320, 2230]
      ]
    };
    let ageLists = this.EchartsMes.age;
    let seriesArr = [];
    for (let i in this.EchartsMes.mounth) {
      this.moneyArr.push([]);
    }
    for (let i in this.EchartsMes.money) {
      for (let j in this.EchartsMes.mounth) {
        this.moneyArr[j].push(this.EchartsMes.money[i][j]);
      }
    }
    for (var i in ageLists) {
      seriesArr.push({
        name: ageLists[i],
        type: "bar",
        stack: "总量",
        label: {
          show: true,
          position: "inside"
        },
        data: this.EchartsMes.count[i],
        data2: this.EchartsMes.money[i]
      });
    }
    this.seriesList = seriesArr;
    console.log(this.seriesList);
    this.getEcharts();
  },
  created() {
    for (var i = new Date().getFullYear(); i > 1900; i--) {
      this.yearList.push({
        value: i,
        label: i
      });
    }
    this.year = new Date().getFullYear();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/censusCharts.vue